import axios from '@/utils/proxy';

// 注册页面相关api
// export const RegisterApi = {
//   // 短信验证码
//   urlGetSmsCode: '/loan/security/getSmsCode',
//   // 图像验证码
//   urlGetkaptcha: '/loan/captcha/getkaptcha',
//   // 注册接口
//   urlRegister: '/loan/security/register',
// }

// 注册页相关接口 - 短信验证码
export const ApiGetSmsCode = (o) => {
  return axios({
    url: '/security/getSmsCode',
    method: 'post',
    ...o,
  })
}
// 注册页相关接口 - 图像验证码
// 此处小贷接口单词拼错 故做区分
export const ApiGetCaptcha = (o) => {
  const appName = o.headers ? o.headers.App_name : ''

  let url = '/captcha/getkaptcha'
  if (o.type === 'loan') {
    url = '/captcha/getkaptcha'
  }
  if (o.type === 'tifi_slice') {
    url = '/captcha/getCaptcha'
  }
  if (appName === 'Champ loan') {
    url = '/captcha/getCaptcha'
  }
  return axios({
    url: url,
    method: 'post',
    ...o,
  })
}
// 注册页相关接口 - 注册接口
export const ApiRegister = (o) => {
  return axios({
    url: '/security/register',
    method: 'post',
    ...o,
  })
}
// 注册页相关接口 - 检查号码是否注册
export const ApiCheckMobileRegister = (o) => {
  return axios({
    url: '/security/checkMobileRegister',
    method: 'post',
    ...o,
  })
}

// 紧急联系人相关api
export const ApiContactVerify = (o) => {
  return axios({
    url: '/user/contactVerify',
    method: 'post',
    ...o,
  })
}

// 获取风控结果
// 审贷结果页面 - 获取风控结果
export const ApiLoanProcessing = (o) => {
  return axios({
    url: '/preCredit/queryRiskManageResult',
    method: 'post',
    ...o,
  })
}

// TODO 为了紧急应对印度封锁部分支付渠道的接口，目前该页面暂未启用
// 印度相关已下架
export const RssushRepaymentMethodApi = {
  // Razorpay的接口
  apiRazorpayGet: '/loan/repay/india/getPaymentLink',
  apiRazorpayCreate: '/loan/repay/india/createPaymentLink',
  apiRazorpayCancel: '/loan/repay/india/cancelPaymentLink',
}

// 根据用户id返回邀请码(认定为用户、邀请码一一对应)
export const ApiGetInviteCodeByCustId = (o) =>{
  return axios({
    url: '/user/getInviteCodeByCustId',
    method: 'get',
    ...o,
  })
}

// 获取banner list
export const ApiGetBannerConf = (params) =>{
  return axios({
    url: '/util/getBannerConfForH5',
    method: 'post',
    baseURL: params.baseURL,
    headers: {
      'Content-Type': 'application/json',
      ...params.headers,
    },
    data: params.data
  })
}

// 获取Kushki的支付状态
export const ApiGetKushkiTranStatus = (o) =>{
  return axios({
    url: '/bank/transactionInStatus',
    method: 'post',
    ...o,
    notify: false,
  })
}

// 获取用户中奖信息列表
export const ApiGetAwardRecords = (o) =>{
  return axios({
    url: '/coupon/getUserAwardRecordsById',
    method: 'post',
    ...o,
  })
}
// 提交用户中奖信息
export const ApiSubmitAwardInfo = (o) =>{
  return axios({
    url: '/coupon/submitUserAwardInfo',
    method: 'post',
    ...o,
  })
}
// 获取特定用户的转盘奖池信息
export const ApiGetAwardPoolInfo = (o) =>{
  return axios({
    url: '/coupon/getAwardPoolInfoById',
    method: 'post',
    ...o,
  })
}

// 获取用户信息 目前用来获取当前用户(token)的邀请码
export const ApiGetInviteCode = (o) =>{
  return axios({
    url: '/user/getInviteCode',
    method: 'post',
    ...o,
  })
}

// 哥伦比亚通过banner/弹窗临时还款接口(哥伦比亚)
export const ApiTemporaryRepayByCo = (o) =>{
  return axios({
    url: '/loan/temporaryRepayByCo',
    method: 'post',
    ...o,
  })
}
